// extracted by mini-css-extract-plugin
export var infoItem = "_s7-2";
export var title = "_s7-0";
export var value = "_s7-1";